/* eslint-disable no-param-reassign */
import { useState } from 'react';
import * as React from 'react';

import TextButton from '@/components/elements/Button/TextButton';
import { BetDataList, BetDetail, Odds } from '@/modelTypes';

import BulkFundSetting from './BulkFundSetting';
import DesiredRefundSetting from './DesiredRefundSetting';
import DistributeFundSetting from './DistributeFundSetting';
import { FundSettingContent, FundWrapper, Icon, TextWrapper } from './style';

interface FundSettingProps {
  raceId: string;
  itemId?: string;
  odds: Odds;
  betDetails: BetDetail[];
  setBetDataList: React.Dispatch<React.SetStateAction<BetDataList>>;
  setOpenList: React.Dispatch<React.SetStateAction<string[]>>;
}
const FundSetting: React.FC<FundSettingProps> = ({
  raceId,
  itemId,
  odds,
  betDetails,
  setBetDataList,
  setOpenList,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <FundWrapper>
      <TextButton size="s" onClick={() => setIsOpen(!isOpen)}>
        <TextWrapper>
          {!itemId && 'まとめて'}
          資金配分
          <Icon isOpen={isOpen} />
        </TextWrapper>
      </TextButton>
      <FundSettingContent isOpen={isOpen}>
        <BulkFundSetting
          raceId={raceId}
          itemId={itemId}
          setBetDataList={setBetDataList}
        />
        <DistributeFundSetting
          raceId={raceId}
          itemId={itemId}
          odds={odds}
          betDetails={betDetails}
          setBetDataList={setBetDataList}
          setOpenList={setOpenList}
        />
        <DesiredRefundSetting
          raceId={raceId}
          itemId={itemId}
          odds={odds}
          setBetDataList={setBetDataList}
          setOpenList={setOpenList}
        />
      </FundSettingContent>
    </FundWrapper>
  );
};

export default FundSetting;
